// extracted by mini-css-extract-plugin
export default {"info":"kRfM1bATzbETKosVGD6UxA=="};